<script setup lang="ts">
import { onClickOutside } from "@vueuse/core";

const { isLoggedIn, logout, user } = useUser();
const accountMenu = ref(null);
const router = useRouter();

const loginModalController = useModal();
const localePath = useLocalePath();
const { formatLink } = useInternationalization(localePath);
const isAccountMenuOpen = ref(false);

onClickOutside(accountMenu, () => (isAccountMenuOpen.value = false));

async function invokeLogout() {
  try {
    await logout();
  } finally {
    isAccountMenuOpen.value = false;
  }
}

async function invokeResetPassword() {
  await router.push(formatLink("/account/recover"));
  loginModalController.close();
}
</script>
<template>
  <ClientOnly>
    <button 
      v-if="!isLoggedIn"
      class="text-white relative bg-transparent border-none"
      data-testid="header-sign-in-link"
      @click="loginModalController.open"
    >
        <img src="assets/images/user-icon.svg" alt="user-icon" class="w-5 h-5 sm:w-5 sm:h-5">
    </button>
    <NuxtLink
      v-else
      :to="formatLink('/account')"
      type="button"
      class="text-white relative bg-transparent border-none"
      data-testid="account-menu-hello-button"
    >
      <img src="assets/images/user-icon.svg" alt="user-icon" class="w-5 h-5 sm:w-5 sm:h-5">
    </NuxtLink>

    <SharedModal :controller="loginModalController">
      <AccountLoginForm
        @close="loginModalController.close"
        @success="loginModalController.close"
      >
        <div class="flex items-center justify-end">
          <div class="text-sm">
            <NuxtLink
              class="font-medium text-black hover:text-red cursor-pointer"
              @click.stop="invokeResetPassword"
            >
              {{$t('account.changePassword')}}
            </NuxtLink>
          </div>
        </div>
      </AccountLoginForm>
    </SharedModal>
  </ClientOnly>
</template>
